/**
 * Mobile attribution lifecycle events, as reported by the attribution SDK and
 * stored on the attribution record.
 *
 * Hoisted from `packages/server/src/domain/types/AttributionTypes.ts`
 * (`AttributionEvents`) and `packages/admin/src/types/attribution.ts`
 * (`AttributionEventType`), which declared identical values under different
 * type and member names. Member names and values follow the server copy, which
 * is the wire source of truth.
 */
export var AfriexAttributionEvent;
(function (AfriexAttributionEvent) {
    AfriexAttributionEvent["APP_REMOVE"] = "app_remove";
    AfriexAttributionEvent["FIRST_OPEN"] = "first_open";
    AfriexAttributionEvent["INSTALL"] = "install";
    AfriexAttributionEvent["REINSTALL"] = "reinstall";
    AfriexAttributionEvent["UNINSTALL"] = "uninstall";
})(AfriexAttributionEvent || (AfriexAttributionEvent = {}));
//# sourceMappingURL=AfriexAttributionEvent.js.map